import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IReceptionNotification, ReceptionType } from "@/models";

@Component({
    name: "NotificationReception",
})

export default class NotificationReception extends Vue {
    @Prop({ required: true })
    public notification: IReceptionNotification;

    constructor() {
        super();
    }

    public goToDetail(): void {
        this.$store.commit("receptions/SET_SELECTED_RECEPTION", this.notification.reception);

        this.$router.push({ name: "receptionDetail" });
    }

    public formatType(): string {
        switch (this.notification.reception.type) {
            case ReceptionType.DryMaterials:
                return "Matières sèches";
            case ReceptionType.Glasswares:
                return "Verrerie";
        }
    }
}
